import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, postData, updateData, deleteData } from '../../../apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select';


const ItemDetail = () => {
    const { isAuthenticated, companyId, permissions, logout, token, userId } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout, userId]);

    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [formData, setFormData] = useState({
        name: '',
        gstRate: '',
        isSubmit: false,
    });
    const [isLoading, setIsLoading] = useState(false);

    //BagMaster

    const [selectedBagmaster, setSelectedBagMaster] = useState("");
    const [bagmasterOptions, setBagmasterOptions] = useState([]);
    const [selectedBagmasterType, setSelectedBagMasterType] = useState("");

    const fetchBagMaster = async () => {
        try {
            const response = await fetchData('BagMasterApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(bag => ({
                    //  value: bag.weightage,
                    value: bag.id,
                    label: bag.weightage
                }));
                setBagmasterOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleBagMasterChange = (selectedOption) => {
        setSelectedBagMasterType(selectedOption);
    };

    useEffect(() => {
        fetchBagMaster();
    }, []);

    const [newRecordData, setNewRecordData] = useState({
        CategoryId: id,
        CompanyId: companyId,
        Name: '',
        Rate: '0',
        HSNCode: '', // new feilds
        OpeningStock: '0',
        CurrentStock: '0',
        TotalStock: '0',
        MinimumStock: '0',
        BagWeight: selectedBagmaster.label,
        GSTRate: '0',
        Description: '',
        MillRate: '0',
        A1price: '0',
        Aprice: '0',
        Bprice: '0',
        Cprice: '0',
        Dprice: '0',
        ItemCode: '',
        Bundle: '0',
    });

    const [updatedData, setUpdateData] = useState({
        CategoryId: id,
        Name: '',
        Rate: '',
        GSTRate: '',
        Description: '',
        HSNCode: '', // new feilds
        OpeningStock: '',
        CurrentStock: '',
        TotalStock: '',
        MinimumStock: '',
        BagWeight: '',
        MillRate: '',
        A1price: '',
        Aprice: '',
        Bprice: '',
        Cprice: '',
        Dprice: '',
        ItemCode: '',
        Bundle: '',
    });


    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    useEffect(() => {
        fetchData('CategoryApi', `/CategoryDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Category Details:', error);
            });

        fetchItemData();
    }, [id]);

    const fetchItemData = async () => {
        try {
            const response = await fetchData('ItemApi', `/${id}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Item', error);
        }
    };

    const openDetailModal = async (item) => {
        try {
            const response = await fetchData('ItemApi', `/ItemDetails/${item.Id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };



    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewRecordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };


    const addRecord = async () => {
        newRecordData.CategoryId = id;
        newRecordData.CompanyId = companyId;
        const weight = selectedBagmasterType.label;
        const BagWeightId= selectedBagmasterType.value;
        newRecordData.BagWeight = weight;
        newRecordData.BagWeightID = BagWeightId;


        // Handle the bundle field
        if (!newRecordData.Bundle) {
            newRecordData.Bundle = 0;
        }

        //  Name validation
        if (!newRecordData.Name) {
            setErrorMessage('Name is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }

        if (!newRecordData.HSNCode) {
            setErrorMessage('HSNCode is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }
        if (!newRecordData.ItemCode) {
            setErrorMessage('ItemCode is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }
        if (!newRecordData.Description) {
            setErrorMessage('Description is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }

        if (!newRecordData.BagWeight) {
            setErrorMessage('BagWeight is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }

        // if (!newRecordData.BagWeightId) {
        //     setErrorMessage('BagWeight is required ! Please fill all required fields.');
        //     setIsLoading(false);
        //     return;
        // }


        try {
            await postData('ItemApi', newRecordData, token);
            setNewRecordData({
                
                CategoryId: id,
                CompanyId: companyId,
                Name: '',
                Rate: '',
                GSTRate: '',
                Description: '',
                HSNCode: '', // new fields
                OpeningStock: '',
                CurrentStock: '',
                TotalStock: '',
                MinimumStock: '',
                BagWeight: '', // Corrected the assignment
                BagWeightID: '',
                MillRate: '',
                A1price: '',
                Aprice: '',
                Bprice: '',
                Cprice: '',
                Dprice: '',
                ItemCode: '', // item code new feild
                Bundle: '',
                CreatedBy: userId,
                CreatedDate: new Date(),
            });
            fetchItemData();
            setIsModalOpen(false);
            selectedBagmaster('');
        } catch (error) {
            console.error('Item Create error:', error);
        }
    };

    const updateRecord = async (event) => {
        event.preventDefault();
        // const weight = selectedBagmasterType.label;
        // updatedData.BagWeight = weight;
        updatedData.BagWeightID = selectedBagmasterType.value;
        // Handle the bundle field
        if (!updatedData.Bundle) {
            updatedData.Bundle = 0;
        }
        if (!updatedData) {
            console.error('No Item details selected.');
            return;
        }

        try {

            await updateData('ItemApi', `${updatedData.Id}`, updatedData, token);
            setUpdateData({
                CategoryId: id,
                Name: '',
                Rate: '',
                GSTRate: '',
                Description: '',
                HSNCode: '', // new fields
                OpeningStock: '',
                CurrentStock: '',
                TotalStock: '',
                MinimumStock: '',
                MillRate: '',
                A1price: '',
                Aprice: '',
                Bprice: '',
                Cprice: '',
                Dprice: '',
                ItemCode: '', // item code new feild
                Bundle: '',
                BagWeight:'', 
                BagWeightID : selectedBagmasterType || selectedBagmasterType.value, 
            });
            fetchItemData();
            setIsDetailModalOpen(false);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };


    const handleDelete = async () => {
        try {
            await deleteData('ItemApi', `${deleteItemId}`, token);
            fetchItemData();
            setDeleteItemId(null);
            setConfirmDialogOpen(false);
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>
            <div className="w-full mb-2 flex">
                <h6 className="uppercase productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Variant - Detail</h6>

                <Tooltip title="Exit">
                    <Link to="/ItemIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                        <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                            Exit <ExitToAppIcon />
                        </Button>
                    </Link>
                </Tooltip>
            </div>

            {/* {errorMessage && <p className="text-red-500">{errorMessage}</p>} */}
            {successMessage && <p className="text-green-500">{successMessage}</p>}


            <div className="w-full pl-4" style={{ width: '100%' }}>
                <div className="bg-teal-700 rounded-lg shadow-lg p-6">
                    <div className="w-full mb-5 flex">
                        <h3 className="text-lg font-semibold mb-4 linkcolor mr-2">{formData.name}</h3>
                        <h4 className="text-lg font-semibold mb-4 linkcolor mr-2">- Sub Category</h4>
                        {hasCreateMasterPermission && (
                            <div className="ml-auto">
                                <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={toggleModal}>
                                    Add Record
                                </button>
                            </div>
                        )}


                        {isModalOpen && (

                            <div className="fixed inset-0 flex items-center justify-center z-10">

                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1200px' }}>
                                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/4 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Weightage">
                                                Weightage <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <Select
                                                value={selectedBagmasterType}
                                                onChange={handleBagMasterChange}
                                                options={bagmasterOptions}
                                                placeholder="BagMaster"
                                                isSearchable
                                            />
                                        </div>

                                        {selectedBagmasterType && (selectedBagmasterType.value === '5 KG' || selectedBagmasterType.value === '10 KG') && (
                                            <div className="w-1/4 mr-2">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Bundle">
                                                    Bundle Unit
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                    type="text"
                                                    name="Bundle"
                                                    placeholder="Enter Bundle Unit"
                                                    value={newRecordData.Bundle}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        )}


                                        <div className="w-1/2 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                                Item Name <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                type="text"
                                                name="Name"
                                                placeholder="Enter Item name"
                                                value={newRecordData.Name}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                                ItemCode <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                                type="text"
                                                name="ItemCode"
                                                placeholder="Enter ItemCode"
                                                value={newRecordData.ItemCode}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                                HSNCode <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                                type="text"
                                                name="HSNCode"
                                                placeholder="Enter HSNCode"
                                                value={newRecordData.HSNCode}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full mb-4 flex">
                                        <div className="w-4/5 mr-4">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Description">
                                                Description <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <textarea
                                                className="shadow appearance-none border rounded w-full h-20 py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                name="Description"
                                                placeholder="Enter Description"
                                                value={newRecordData.Description}
                                                onChange={handleInputChange}
                                            />
                                        </div>



                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                MRP <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Rate"
                                                placeholder="Enter MRP"
                                                value={newRecordData.Rate}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="GST">
                                                GST % <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="GSTRate"
                                                placeholder="Enter GST"
                                                value={newRecordData.GSTRate}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        {/* Mill Price */}
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                Mill Rate <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="MillRate"
                                                placeholder="Enter MillRate"
                                                value={newRecordData.MillRate}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        {/* A1price */}
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                A1 price <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="A1price"
                                                placeholder="Enter A1price"
                                                value={newRecordData.A1price}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        {/* Aprice */}
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                A price <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Aprice"
                                                placeholder="Enter Aprice"
                                                value={newRecordData.Aprice}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                    </div>

                                    {/* here adding stock sections */}

                                    <div className="w-full mb-4 flex">

                                        {/* Bprice */}

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                B price <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Bprice"
                                                placeholder="Enter Bprice"
                                                value={newRecordData.Bprice}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        {/* Cprice */}

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                C price <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Cprice"
                                                placeholder="Enter Cprice"
                                                value={newRecordData.Cprice}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        {/* Dprice */}

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                D price <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Dprice"
                                                placeholder="Enter Dprice"
                                                value={newRecordData.Dprice}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="OpeningStock">
                                                OpeningStock  <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="OpeningStock"
                                                placeholder="Enter OpeningStock"
                                                value={newRecordData.OpeningStock}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="TotalStock">
                                                TotalStock  <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="TotalStock"
                                                placeholder="Enter TotalStock"
                                                value={newRecordData.TotalStock}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="CurrentStock">
                                                CurrentStock  <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="CurrentStock"
                                                placeholder="Enter CurrentStock"
                                                value={newRecordData.CurrentStock}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MinimumStock">
                                                MinimumStock  <sapn style={{ color: 'red', fontSize: '14px' }}>*</sapn>
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="MinimumStock"
                                                placeholder="Enter MinimumStock"
                                                value={newRecordData.MinimumStock}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    {/* end here */}
                                    <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                        <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addRecord}>
                                            Add Record
                                        </button>
                                        <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className='w-full mb-5 flex' style={{ maxHeight: '400px', overflowY: 'auto', width: '100%', marginTop: '-40px' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#f3f3f3' }}> {/* Set background color */}
                                    <TableRow>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'left' }}>Name</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>Bag(KG)</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>MRP</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>GST</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>Mill Rate</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>A1</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>A</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>B</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>C</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>D</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data && data.map(item => (
                                        <TableRow key={item.Id}>
                                            <TableCell className="customTableCell" sx={{ width: '450px', padding: '5px', textAlign: 'left' }}>{item.Name}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '150px', padding: '5px', textAlign: 'center' }}>{item.BagWeight}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '100px', padding: '5px', textAlign: 'center' }}>{item.Rate}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '100px', padding: '5px', textAlign: 'center' }}>{item.GSTRate}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '100px', padding: '5px', textAlign: 'center' }}>{item.MillRate}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '100px', padding: '5px', textAlign: 'center' }}>{item.A1price}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '100px', padding: '5px', textAlign: 'center' }}>{item.Aprice}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '100px', padding: '5px', textAlign: 'center' }}>{item.Bprice}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '100px', padding: '5px', textAlign: 'center' }}>{item.Cprice}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '100px', padding: '5px', textAlign: 'center' }}>{item.Dprice}</TableCell>
                                            <TableCell className="customTableCell" sx={{ padding: '5px', width: '150px', padding: '5px', textAlign: 'center' }}>

                                                <IconButton onClick={() => openDetailModal(item)}>
                                                    <ArrowForward style={{ color: 'darkgoldenrod', fontWeight: 'bold', height: '20px' }} />
                                                </IconButton>
                                                {hasDeleteMasterPermission && (
                                                    <IconButton onClick={() => openConfirmDialog(item.Id)}>
                                                        <DeleteIcon style={{ color: 'brown', fontWeight: 'bold', height: '20px' }} />
                                                    </IconButton>
                                                )}

                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>

                                {/* Delete confirmation dialog */}
                                <Dialog
                                    open={confirmDialogOpen}
                                    onClose={closeConfirmDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Are you sure you want to delete this record?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <button onClick={closeConfirmDialog} className="cancelbutton">
                                            Cancel
                                        </button>
                                        <button onClick={handleDelete} className="confirmbutton">
                                            Confirm
                                        </button>
                                    </DialogActions>
                                </Dialog>
                            </Table>
                        </TableContainer>

                        {isDetailModalOpen && (
                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1200px' }}> {/* Adjust width here */}
                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/4 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Weightage">
                                                Weightage
                                            </label>

                                            <Select
                                                //value={selectedBagmasterType || (updatedData.BagWeight ? { value: updatedData.BagWeight, label: updatedData.BagWeight } : '')}
                                                value={selectedBagmasterType || (updatedData.BagWeight ? { value: updatedData.BagWeightId, label: updatedData.BagWeight } : '')}
                                                onChange={handleBagMasterChange}
                                                options={bagmasterOptions}
                                                placeholder="BagMaster"
                                                isSearchable
                                            />

                                        </div>

                                        <div className="w-1/4 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Bundle">
                                                Bundle Unit
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                type="text"
                                                name="Bundle"
                                                placeholder="Enter Bundle Unit"
                                                value={updatedData.Bundle}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        {(selectedBagmasterType && (selectedBagmasterType.value === '5 KG' || selectedBagmasterType.value === '10 KG')) ||
                                            (updatedData.BagWeight === '5 KG' || updatedData.BagWeight === '10 KG') && (
                                                <div className="w-1/4 mr-2">
                                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Bundle">
                                                        Bundle Unit
                                                    </label>
                                                    <input
                                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                        type="text"
                                                        name="Bundle"
                                                        placeholder="Enter Bundle Unit"
                                                        value={updatedData.Bundle}
                                                        onChange={handleUpdateInputChange}
                                                    />
                                                </div>
                                            )}
                                        <div className="w-1/2 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                                Item Name
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                type="text"
                                                name="Name"
                                                placeholder="Enter Item name"
                                                value={updatedData.Name}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                                ItemCode
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                                type="text"
                                                name="ItemCode"
                                                placeholder="Enter ItemCode"
                                                value={updatedData.ItemCode}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                                HSNCode
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                                type="text"
                                                name="HSNCode"
                                                placeholder="Enter HSNCode"
                                                value={updatedData.HSNCode}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                    </div>


                                    <div className="w-full mb-4 flex">
                                        <div className="w-4/5 mr-4">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Description">
                                                Description
                                            </label>
                                            <textarea
                                                className="shadow appearance-none border rounded w-full h-20 py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                name="Description"
                                                placeholder="Enter Description"
                                                value={updatedData.Description}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>



                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="ContactNumber1">
                                                MRP
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Rate"
                                                placeholder="Enter MRP"
                                                value={updatedData.Rate}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="ContactNumber2">
                                                GST %
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                type="text"
                                                name="GSTRate"
                                                placeholder="Enter GST Rate"
                                                value={updatedData.GSTRate}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        {/* Millprice */}
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                Mill Rate
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="MillRate"
                                                placeholder="Enter MillRate"
                                                value={updatedData.MillRate}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        {/* A1price */}
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                A1 price
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="A1price"
                                                placeholder="Enter A1price"
                                                value={updatedData.A1price}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        {/* Aprice */}
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                A price
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Aprice"
                                                placeholder="Enter Aprice"
                                                value={updatedData.Aprice}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>

                                    </div>

                                    {/* here adding stock sections */}

                                    <div className="w-full mb-4 flex">

                                        {/* Bprice */}

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                B price
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Bprice"
                                                placeholder="Enter Bprice"
                                                value={updatedData.Bprice}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        {/* Cprice */}

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                C price
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Cprice"
                                                placeholder="Enter Cprice"
                                                value={updatedData.Cprice}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        {/* Dprice */}

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                D price
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Dprice"
                                                placeholder="Enter Dprice"
                                                value={updatedData.Dprice}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="OpeningStock">
                                                OpeningStock
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="OpeningStock"
                                                placeholder="Enter OpeningStock"
                                                value={updatedData.OpeningStock}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="TotalStock">
                                                TotalStock
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="TotalStock"
                                                placeholder="Enter TotalStock"
                                                value={updatedData.TotalStock}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="CurrentStock">
                                                CurrentStock
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="CurrentStock"
                                                placeholder="Enter CurrentStock"
                                                value={updatedData.CurrentStock}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MinimumStock">
                                                MinimumStock
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="MinimumStock"
                                                placeholder="Enter MinimumStock"
                                                value={updatedData.MinimumStock}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                    </div>
                                    {/* end here */}

                                    <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                        {hasEditMasterPermission && (
                                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={updateRecord}>
                                                Update Record
                                            </button>
                                        )}
                                        <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModalBranch}>
                                            Cancel
                                        </button>
                                    </div>




                                </div>
                            </div>
                        )}


                    </div>
                </div>
            </div>
        </div>

    );
};

export default ItemDetail;
